import { render } from "./StatistiquePage.vue?vue&type=template&id=8dd9c3fe&ts=true"
import script from "./StatistiquePage.vue?vue&type=script&lang=ts"
export * from "./StatistiquePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__